/**
 * !NOTE: Any changes to this file requires Migration to update the materialized view in the Redshift database
 */

export const wholeHouseExteriorFinishes = [
	// wholeHouseExteriorFinishes
	'volumetricsTotalWholeHouseExteriorFinishesLineal',
	'volumetricsTotalWholeHouseExteriorFinishesSquare',
	'volumetricsTotalWholeHouseExteriorFinishesCubic',
	'volumetricsTotalWholeHouseExteriorFinishesCount',
	'volumetricsTotalWholeHouseExteriorFinishesCurrency',
] as const;

export const wholeHouse = [
	// Whole House
	'volumetricsTotalWholeHouseLineal',
	'volumetricsTotalWholeHouseSquare',
	'volumetricsTotalWholeHouseCubic',
	'volumetricsTotalWholeHouseCount',
	'volumetricsTotalWholeHouseCurrency',
	// wholeHouseFoundation
	'volumetricsTotalWholeHouseFoundationLineal',
	'volumetricsTotalWholeHouseFoundationSquare',
	'volumetricsTotalWholeHouseFoundationCubic',
	'volumetricsTotalWholeHouseFoundationCount',
	'volumetricsTotalWholeHouseFoundationCurrency',
	// wholeHouseFoundationBasement
	'volumetricsTotalWholeHouseFoundationBasementLineal',
	'volumetricsTotalWholeHouseFoundationBasementSquare',
	'volumetricsTotalWholeHouseFoundationBasementCubic',
	'volumetricsTotalWholeHouseFoundationBasementCount',
	'volumetricsTotalWholeHouseFoundationBasementCurrency',
	// wholeHouseRoofing
	'volumetricsTotalWholeHouseRoofingLineal',
	'volumetricsTotalWholeHouseRoofingSquare',
	'volumetricsTotalWholeHouseRoofingCubic',
	'volumetricsTotalWholeHouseRoofingCount',
	'volumetricsTotalWholeHouseRoofingCurrency',

	...wholeHouseExteriorFinishes,

	// wholeHouseFraming
	'volumetricsTotalWholeHouseFramingLineal',
	'volumetricsTotalWholeHouseFramingSquare',
	'volumetricsTotalWholeHouseFramingCubic',
	'volumetricsTotalWholeHouseFramingCount',
	'volumetricsTotalWholeHouseFramingCurrency',
	// wholeHouseDimensionalFloorRoofLayoutFloorJoistLayout
	'volumetricsTotalWholeHouseDimensionalFloorRoofLayoutFloorJoistLayoutLineal',
	'volumetricsTotalWholeHouseDimensionalFloorRoofLayoutFloorJoistLayoutSquare',
	'volumetricsTotalWholeHouseDimensionalFloorRoofLayoutFloorJoistLayoutCubic',
	'volumetricsTotalWholeHouseDimensionalFloorRoofLayoutFloorJoistLayoutCount',
	'volumetricsTotalWholeHouseDimensionalFloorRoofLayoutFloorJoistLayoutCurrency',
	// wholeHouseDimensionalFloorRoofLayoutCeilingJoistLayout
	'volumetricsTotalWholeHouseDimensionalFloorRoofLayoutCeilingJoistLayoutLineal',
	'volumetricsTotalWholeHouseDimensionalFloorRoofLayoutCeilingJoistLayoutSquare',
	'volumetricsTotalWholeHouseDimensionalFloorRoofLayoutCeilingJoistLayoutCubic',
	'volumetricsTotalWholeHouseDimensionalFloorRoofLayoutCeilingJoistLayoutCount',
	'volumetricsTotalWholeHouseDimensionalFloorRoofLayoutCeilingJoistLayoutCurrency',
	// wholeHouseDimensionalFloorRoofLayoutRoofRafterLayout
	'volumetricsTotalWholeHouseDimensionalFloorRoofLayoutRoofRafterLayoutLineal',
	'volumetricsTotalWholeHouseDimensionalFloorRoofLayoutRoofRafterLayoutSquare',
	'volumetricsTotalWholeHouseDimensionalFloorRoofLayoutRoofRafterLayoutCubic',
	'volumetricsTotalWholeHouseDimensionalFloorRoofLayoutRoofRafterLayoutCount',
	'volumetricsTotalWholeHouseDimensionalFloorRoofLayoutRoofRafterLayoutCurrency',
	// wholeHouseDrywall
	'volumetricsTotalWholeHouseDrywallLineal',
	'volumetricsTotalWholeHouseDrywallSquare',
	'volumetricsTotalWholeHouseDrywallCubic',
	'volumetricsTotalWholeHouseDrywallCount',
	'volumetricsTotalWholeHouseDrywallCurrency',
	// wholeHouseInsulation
	'volumetricsTotalWholeHouseInsulationLineal',
	'volumetricsTotalWholeHouseInsulationSquare',
	'volumetricsTotalWholeHouseInsulationCubic',
	'volumetricsTotalWholeHouseInsulationCount',
	'volumetricsTotalWholeHouseInsulationCurrency',
	// wholeHouseMillwork
	'volumetricsTotalWholeHouseMillworkLineal',
	'volumetricsTotalWholeHouseMillworkSquare',
	'volumetricsTotalWholeHouseMillworkCubic',
	'volumetricsTotalWholeHouseMillworkCount',
	'volumetricsTotalWholeHouseMillworkCurrency',
] as const;

export const totals = [
	// Frame
	'volumetricsTotalFrameLineal',
	'volumetricsTotalFrameSquare',
	'volumetricsTotalFrameCubic',
	'volumetricsTotalFrameCount',
	'volumetricsTotalFrameCurrency',
	// Floor
	'volumetricsTotalFloorLineal',
	'volumetricsTotalFloorSquare',
	'volumetricsTotalFloorCubic',
	'volumetricsTotalFloorCount',
	'volumetricsTotalFloorCurrency',
	// Flooring
	'volumetricsTotalFlooringLineal',
	'volumetricsTotalFlooringSquare',
	'volumetricsTotalFlooringCubic',
	'volumetricsTotalFlooringCount',
	'volumetricsTotalFlooringCurrency',
	// Roof
	'volumetricsTotalRoofLineal',
	'volumetricsTotalRoofSquare',
	'volumetricsTotalRoofCubic',
	'volumetricsTotalRoofCount',
	'volumetricsTotalRoofCurrency',
	// Whole House
	...wholeHouse,
	// Rafters
	'volumetricsTotalRaftersLineal',
	'volumetricsTotalRaftersSquare',
	'volumetricsTotalRaftersCubic',
	'volumetricsTotalRaftersCount',
	'volumetricsTotalRaftersCurrency',
	// Lintel
	'volumetricsTotalLintelLineal',
	'volumetricsTotalLintelSquare',
	'volumetricsTotalLintelCubic',
	'volumetricsTotalLintelCount',
	'volumetricsTotalLintelCurrency',
] as const;

export const uniqueTrussTypes = [
	//TODO: enable totalRequirementsFlooringRow
	'volumetricsUniqTrussTypesFrame',
	'volumetricsUniqTrussTypesFloor',
	'volumetricsUniqTrussTypesFlooring',
	'volumetricsUniqTrussTypesRoof',
	'volumetricsUniqTrussTypesWholeHouse',
	'volumetricsUniqTrussTypesRafters',
] as const;
